var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunset0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_27496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83317 8.24984H0.916504M2.89381 5.64381L2.24563 4.99563M8.10582 5.64381L8.75401 4.99563M10.0832 8.24984H9.1665M3.20817 8.24984C3.20817 6.98418 4.23418 5.95817 5.49984 5.95817C6.76549 5.95817 7.7915 6.98418 7.7915 8.24984M10.0832 10.0832H0.916504M7.33317 2.2915L5.49984 4.12484M5.49984 4.12484L3.6665 2.2915M5.49984 4.12484V0.916504",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_27496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset0);
export default __webpack_public_path__ + "static/media/sunset0.07088f2545ef7f48f5327b030a4dbca2.svg";
export { ForwardRef as ReactComponent };